import axios from "axios";
import { useEffect, useState } from "react";
import { NotificationManager } from "react-notifications";
import Modal from "../../../components/Modal/Modal";
import useAuth from "../../../hooks/useAuth";
import { BASE_URL } from "../../../utils/Element";
import AddPropertyHistoryData from "../components/AddPropertyHistoryData";

const initialFormData = {
  sold_price: "",
  sold_date: "",
  sold_cap_rate: "",
  seller: "",
  buyer: "",
};

const EditPropertyHistoryModal = ({ showModal, onClose, selectedPropertyHistory, onPropertyHistoryAdded }) => {
  const [config] = useAuth();
  const [error, setError] = useState();
  const [formData, setFormData] = useState(initialFormData);
console.log('wefwef',selectedPropertyHistory)
  useEffect(() => {
    // if (selectedPropertyHistory) {
      setFormData({
        sold_date: selectedPropertyHistory?.sold_date || "",
        sold_price: selectedPropertyHistory?.sold_price || "",
        sold_cap_rate: selectedPropertyHistory?.sold_cap_rate || "",
        seller: {
          id:selectedPropertyHistory?.seller_id  || "",
          name:selectedPropertyHistory?.seller   || ""
        },
        buyer:{
          id:selectedPropertyHistory?.buyer_id  || "",
          name:selectedPropertyHistory?.buyer   || ""
        },
      });
    // }
  }, [selectedPropertyHistory]);

  const handleCancel = () => {
    onClose();
    setError();
    setFormData(selectedPropertyHistory);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const dataToSend = {
      sold_price: formData?.sold_price,
      sold_date: formData?.sold_date,
      sold_cap_rate: formData?.sold_cap_rate,
      seller: formData?.seller || "",
      buyer: formData?.buyer || "",

    };
    axios
      .post(`${BASE_URL}/property-history-edit/${selectedPropertyHistory?.id}`, dataToSend, config)
      .then(() => {
        handleCancel();
        onPropertyHistoryAdded();
      })
      .catch((err) => {
        setError(err?.response?.data?.errors);
        if (err.response?.data?.message && err.response?.data?.message !== "Too Many Attempts.") {
          NotificationManager.error(err.response?.data?.message);
        }
      });
  };

  const clearError = (field) => {
    setError((prev) => ({ ...prev, [field]: "" }));
  };

  return (
    <Modal title={"Edit Property Value"} desc={"Edit historical values of this property"} show={showModal} onClose={handleCancel}>
      <AddPropertyHistoryData
        formData={formData}
        error={error}
        onSetFormData={(value) => {
          setFormData(value);
        }}
        clearError={clearError}
        handleSubmit={handleSubmit}
        handleCancel={handleCancel}
      />
    </Modal>
  );
};

export default EditPropertyHistoryModal;
